import * as actionTypes from "../ActionTypes";

export const readEntityContentAnalyticsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ENTITY_CONTENT_ANALYTICS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readEntityContentAnalyticsSuccess = (data) => ({
  type: actionTypes.READ_ENTITY_CONTENT_ANALYTICS_SUCCESS,
  payload: data,
});

export const readEntityContentAnalyticsFailure = (error) => ({
  type: actionTypes.READ_ENTITY_CONTENT_ANALYTICS_FAILURE,
  payload: error,
});

export const readEntityContentDetailsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ENTITY_CONTENT_DETAILS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readEntityContentDetailsSuccess = (data) => ({
  type: actionTypes.READ_ENTITY_CONTENT_DETAILS_SUCCESS,
  payload: data,
});

export const readEntityContentDetailsFailure = (error) => ({
  type: actionTypes.READ_ENTITY_CONTENT_DETAILS_FAILURE,
  payload: error,
});

export const readEntityContentViewsAnalyticsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readEntityContentViewsAnalyticsSuccess = (data) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_SUCCESS,
  payload: data,
});

export const readEntityContentViewsAnalyticsFailure = (error) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_FAILURE,
  payload: error,
});

export const readEntityContentViewsTrendingRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readEntityContentViewsTrendingSuccess = (data) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_SUCCESS,
  payload: data,
});

export const readEntityContentViewsTrendingFailure = (error) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_FAILURE,
  payload: error,
});

export const readEntityContentViewsDetailsRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const readEntityContentViewsDetailsSuccess = (data) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_SUCCESS,
  payload: data,
});

export const readEntityContentViewsDetailsFailure = (error) => ({
  type: actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_FAILURE,
  payload: error,
});
